import { Badge } from "@productlane/ui"

import { ReportingKpiCard } from "@/components/reporting/charts"
import { api } from "@/lib/api"
import { resolutionRateTrend } from "./resolution-rate-trend"

const usd = (value: number) =>
	`$${value.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`

export function AiAgentKpiTiles() {
	const kpis = api.analytics.aiAgentKpis.useQuery({})
	const spend = api.analytics.aiSpendByWorkspace.useQuery(
		{ period: "month" },
		{ staleTime: 30000 },
	)

	const resolution = api.analytics.aiResolutionRateChart.useQuery({})

	const totals = spend.data?.totals
	const trend = resolutionRateTrend(resolution.data?.chartData ?? [])

	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
			<ReportingKpiCard
				label="AI resolution rate"
				isLoading={resolution.isLoading}
				value={trend ? `${trend.latest.rate}%` : "-"}
				hint={
					trend
						? `Last full week, ${trend.latest.aiResolved} of ${trend.latest.total} AI-involved threads`
						: undefined
				}
				footer={
					trend && trend.changes.length > 0 ? (
						<div className="flex flex-wrap gap-1.5">
							{trend.changes.map((change) => (
								<Badge
									key={change.weeks}
									size="sm"
									variant={
										change.points > 0
											? "green"
											: change.points < 0
												? "red"
												: "default"
									}
								>
									{change.points > 0 ? "+" : ""}
									{change.points} pts vs {change.weeks} weeks ago
								</Badge>
							))}
						</div>
					) : undefined
				}
			/>
			<ReportingKpiCard
				label="Accounts metered"
				isLoading={kpis.isLoading}
				value={
					kpis.data
						? `${kpis.data.meteredAccounts} of ${kpis.data.payingAccounts}`
						: "-"
				}
				hint="Paying accounts with pay per use on"
			/>
			<ReportingKpiCard
				label="Productlane Agent in use"
				isLoading={kpis.isLoading}
				value={
					kpis.data
						? `${kpis.data.agentActiveAccounts} of ${kpis.data.payingAccounts}`
						: "-"
				}
				hint={
					kpis.data
						? `Paying accounts where the agent answered a customer in the last ${kpis.data.agentActiveWindowDays} days. ${kpis.data.aiEnabledAccounts} have it switched on.`
						: undefined
				}
			/>
			<ReportingKpiCard
				label="Invoiced this month"
				isLoading={spend.isLoading}
				value={totals ? usd(totals.invoicedUsd) : "-"}
				hint={
					totals
						? `${usd(totals.invoicedTokensUsd)} tokens + ${usd(totals.invoicedResolutionsUsd)} resolutions, against ${usd(totals.providerCostUsd)} of AI cost`
						: undefined
				}
			/>
		</div>
	)
}
